// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section inject=\"patient-summary\"></section>\n<section inject=\"appointment-list\"></section>\n";
},"useData":true});
